module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-Cond.837bb19.ttf";